module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_plan_included_01_black-d209df7ef8e6258e3a080e63c373f301.png";